export * from './PermissionEvent2Detail';
